<div class="flex flex-col items-center justify-center max-w-md mx-auto w-full">
  <div class="w-full flex flex-col gap-4">
    <h2 class="text-xl font-bold text-white text-center">Verify OTP</h2>
    <p class="text-sm text-white text-center mb-4">Enter the 6-digit code sent to your phone</p>

    <ngx-otp-input autocomplete="one-time-code" style="align-self: anchor-center"  #otpInput [options]="otpOptions" (otpComplete)="otpCompleted($event)">
    </ngx-otp-input>

    <div *ngIf="errorMessage" class="text-red-400 text-sm text-center mt-2">
      {{ errorMessage }}
    </div>

    <div *ngIf="otpSent" class="text-green-400 text-center mt-2">
      <p class="text-sm">OTP Sent Successfully</p>
    </div>

    
    <div class="flex justify-center items-center gap-2 mt-2 text-white">
      <span class="text-sm">Didn't receive the code?</span>
      <button class="text-sm font-medium hover:underline" [disabled]="resendDisabled" (click)="resendOtp()">
        {{ resendDisabled ? 'Resend in ' + resendTimer + 's' : 'Resend OTP' }}
      </button>
    </div>
  </div>
</div>